import { httpClient } from '../http/httpClient'
import { PartnerType } from '@/app/utils/partners.enum'

export type MakeProposalRequest = {
  customerId: string
}

export type MakeProposalResponse = {
  sellerId: string
  customerId: string
  intermediaryId: string
  authorizationLink: string
  linkExpirationDate: string
  type: string
  _id: string
  createdAt: string
  updatedAt: string
  __v: number
}

export async function makeProposal(
  payload: MakeProposalRequest,
): Promise<MakeProposalResponse> {
  const { data } = await httpClient
    .post<MakeProposalResponse>('/pan', payload, { journey: PartnerType.PAN })
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
